import {
  Box,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputAdornment,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NumericFormat } from "react-number-format";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import * as constants from "../../../../constants";
import CustomAutocomplete from "../../../../shared/AutoComplete";
import ContainedButton from "../../../../shared/Button/CustomContainedButton";
import OutlinedButton from "../../../../shared/Button/customOutlinedButton";
import CustomDatePicker from "../../../../shared/CustomDate";
import CustomTextField from "../../../../shared/CustomTextFeild";
import { RootState } from "../../../../store/store";
import CancelPopUp from "../../../PopUp/PopUp";
import { getRCBOSourceListByPid } from "../../services/RCBOInvoices/RCBOInvoiceServices";
import {
  SectionTitle,
  StyledOneChildContainer,
  StyledParentContainer,
  StyledTwoChildContainer,
} from "../../StyledComponents/Container";
import { StyledInputLabel } from "../../StyledComponents/InputLabel";
import { formatCurrency } from "../../Utils/formatUtils";
import { notifyUser } from "../../Utils/notifyUser";
import { getTodayDate } from "../../services/Settings/SystemSettingsService";

const MakePayment = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const userInfo = useSelector((state: RootState) => state.auth);
  const { t } = useTranslation();
  const translate = t as (key: string) => string;

  const [rowData, setRowData] = useState<any>(location.state.rowData || {});
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [amount, setAmount] = useState<string>("");
  const [outstandingBalance, setOutstandingBalance] = useState<string>("");
  const [dueDate, setDueDate] = useState<string | null>(null);
  const [invoiceDate, setInvoiceDate] = useState<string | null>(null);
  const [postingDescription, setPostingDescription] = useState<string>("");
  const [netsuiteInvoiceNumber, setNetsuiteInvoiceNumber] =
    useState<string>("");
  const [source, setSource] = useState<any>(null);
  const [sourceAmount, setSourceAmount] = useState<number>(0);
  const [radioPayment, setRadioPayment] = useState<string>("amountDue");
  const [OtherpaymentAmount, setOtherPaymentAmount] = useState<number>();
  const [todayDate, setTodayDate] = useState<string | null>(null);
  const [paymentDate, setPaymentDate] = useState<string>("");
  const [openPopUp, setOpenPopUp] = useState(false);
  const [sourceList, setSourceList] = useState<any>([]);
  const [errors, setErrors] = useState({
    amountDue: "",
    source: "",
    OtherpaymentAmount: "",
  });
  const restrictedRoles = [
    constants.ROLES_READ_ONLY_ALL_LOCATIONS,
    constants.ROLES_READ_ONLY_USER
  ]
  const handleCancel = () => {
    setOpenPopUp(true);
  };

  const handlePopUpClose = () => {
    setOpenPopUp(false);
  };

  function handleConfirm() {
    navigate("/rcboInvoiceSummaryListing");
  }

  useEffect(() => {
    fetchDateFromDB();
  }, []);

  
  useEffect(() => {
    if (todayDate) {
      setPaymentDate(getLocalToday());
    }
  }, [todayDate]);
  const getLocalToday = () => {
    if (!todayDate) return "";
    return todayDate.split("T")[0];
  };
  async function fetchDateFromDB() {
    try {
      const response: any = await getTodayDate(constants.ATTRIBUTE_NAME.SETTING_TODAY_SYSDATE_TEST_ENV_ONLY, userInfo.clientId);
      let dateStr: any = response.data.data;
      setTodayDate(dateStr);
    } catch (error) {
      console.error("Error fetching date:", error);
    }
  }
  const handleSourceChange = (event: any, newValue: any) => {
    if (!newValue) {
      setSource(null);
      setErrors((prevErrors) => ({
        ...prevErrors,
        source: translate("pleaseSelectSource"),
      }));
    } else {
      setSource(newValue);
      setSourceAmount(newValue.availBalance);
      setErrors((prevErrors) => ({
        ...prevErrors,
        source: "",
      }));
    }
  };

  const handlePaymentAmountChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;
    setRadioPayment(value);
    if (value === "amountDue") {
      setOtherPaymentAmount(undefined);
    }
  };

  const handleOtherPaymentAmountChange = (input: any) => {
    // normalize: accept either event or direct value
    const value = typeof input === "string" ? input : input?.target?.value ?? "";

    let parsed = parseFloat(value);
    if (isNaN(parsed)) {
      parsed = 0;
    }

    setOtherPaymentAmount(parsed);

    if (!value) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        OtherpaymentAmount: translate("pleaseEnterAmount"),
      }));
    } else if (
      source.name !== "Checking" &&
      parsed >= source?.availBalance
    ) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        OtherpaymentAmount: translate("amountGreaterThanBalance"),
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        OtherpaymentAmount: "",
      }));
    }
  };




  const handleContinueClick = () => {
    if (handleValidation()) {
      const formData = {
        ...rowData,
        invoiceNumber,
        amount,
        outstandingBalance,
        dueDate,
        invoiceDate,
        postingDescription,
        netsuiteInvoiceNumber,
        source,
        sourceAmount,
        radioPayment,
        OtherpaymentAmount: OtherpaymentAmount,
        paymentDate,
      };
      navigate("/rcboInvoiceSubmit", { state: formData });
    }
  };

  async function getSourceList() {
    try {
      const responseList = await getRCBOSourceListByPid(
        userInfo.defaultParticipantId,
        userInfo.clientId
      );

      if (responseList.status === constants.STATUS_CODES.SUCCESS) {
        // const { cashAccounts, funds } = responseList.data.data;
        // // Normalize cashAccounts object
        // const cashAccountEntry = {
        //     fundId: cashAccounts.fundId,
        //     fundName: cashAccounts.fundName,
        //     fundType: cashAccounts.fundType,
        //     description: cashAccounts.description,
        //     availableBalance: cashAccounts.availableBalance
        // };

        // // Map funds array to desired shape
        // const mappedFunds = funds.map((fund: any) => ({
        //     fundId: fund.fundId,
        //     fundName: fund.fundName,
        //     fundType: fund.fundType,
        //     description: fund.description,
        //     availableBalance: fund.availableBalance
        // }));

        // // Combine and set state
        setSourceList(responseList.data.data);
      } else {
        setSourceList([]);
        notifyUser(
          responseList.response.data.message,
          "error",
          translate("makePayment")
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  useEffect(() => {
    getSourceList();
    if (location.state.submitData) {
      const data = location.state.submitData;
      setInvoiceNumber(data?.invoiceNumber);
      setAmount(data?.amount);
      setOutstandingBalance(data?.outstandingBalance);
      setDueDate(data?.dueDate);
      setInvoiceDate(data?.invoiceDate);
      setPostingDescription(data?.postingDescription);
      setNetsuiteInvoiceNumber(data?.netsuiteInvoiceNumber);
      setSource(data?.source);
      setSourceAmount(data?.sourceAmount);
      setRadioPayment(data?.radioPayment);
      setOtherPaymentAmount(data?.OtherpaymentAmount ? parseFloat(data?.OtherpaymentAmount) : 0);
      setPaymentDate(data?.paymentDate);
    }
    if (location.state.rowData) {
      const rowData = location.state.rowData;
      setInvoiceNumber(rowData?.invoiceNumber);
      setAmount(rowData?.amount);
      setOutstandingBalance(rowData?.outstandingBalance);
      setDueDate(rowData?.dueDate);
      setInvoiceDate(rowData?.invoiceDate);
      setPostingDescription(rowData?.postingDescription);
      setNetsuiteInvoiceNumber(rowData?.netsuiteInvoiceNumber);
    }
  }, []);

  useEffect(() => {
    if (location.state?.rowData && sourceList && sourceList.length > 0) {
      const foundSource = sourceList.find(
        (option: any) => option.name === "Checking"
      );
      setSource(foundSource ? foundSource : null);
    }
  }, [sourceList]);

  const handleValidation = () => {
    let isValid = true;

    const availBalance = Number(source?.availableBalance);
    const outstanding = Number(
      parseFloat(outstandingBalance.replace(/[$,]/g, ""))
    );
    const otherAmount = Number(OtherpaymentAmount);

    if (!source) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        source: translate("pleaseSelectSource"),
      }));
      isValid = false;
      // } else if (source.name != "Checking" && otherAmount && otherAmount > availBalance) {
      //     setErrors(prevErrors => ({
      //         ...prevErrors,
      //         source: translate('Insufficient Fund Balance!')
      //     }));
      //     isValid = false;
    }

    if (radioPayment === "amountDue") {
      if (source.name != "Checking" && outstanding > availBalance) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          amountDue: translate("eAmountIsGreaterThanSourceAvailableBalance"),
        }));
        isValid = false;
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          amountDue: "",
        }));
      }
    }

    if (radioPayment === "OtherAmount") {
      if (!otherAmount) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          amountDue: "",
          OtherpaymentAmount: translate("pleaseEnterAmount"),
        }));
        isValid = false;
      } else if (source.name != "Checking" && otherAmount > availBalance) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          amountDue: "",
          OtherpaymentAmount: translate(
            "amountIsGreaterThanSourceAvailableBalance"
          ),
        }));
        isValid = false;
      } else if (otherAmount > outstanding) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          amountDue: "",
          OtherpaymentAmount: translate("amountIsGreaterThanBalanceDue"),
        }));
        isValid = false;
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          amountDue: "",
          OtherpaymentAmount: "",
        }));
      }
    }

    return isValid;
  };

  return (
    <StyledParentContainer>
      <StyledOneChildContainer>
        <StyledTwoChildContainer sx={{ border: "none" }}>
          <SectionTitle>
            {translate("makePayment")} - {invoiceNumber}
          </SectionTitle>
          <StyledTwoChildContainer>
            <Box sx={{ padding: "40px" }}>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                  <CustomTextField
                    labelText={translate("originalInvoiceAmount")}
                    value={amount}
                    readOnly
                  />
                </Grid>
                <Grid
                  size={{ xs: 12, sm: 6, lg: 4 }}
                  sx={{ display: { lg: "none", xs: "block" } }}
                ></Grid>
                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                  <CustomTextField
                    labelText={translate("outstandingBalance")}
                    value={outstandingBalance}
                    readOnly
                  />
                </Grid>
                <Grid
                  size={{ xs: 12, sm: 6, lg: 4 }}
                  sx={{ display: { lg: "none", xs: "block" } }}
                ></Grid>
                <Grid
                  size={{ xs: 12, sm: 0, lg: 4 }}
                  sx={{ display: { lg: "block", sm: "none", xs: "block" } }}
                ></Grid>
                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                  <CustomTextField
                    labelText={translate("dueDate")}
                    value={dueDate}
                    readOnly
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 6.1, lg: 4 }}>
                  <CustomAutocomplete
                    labelText={translate("source")}
                    required
                    value={source || null}
                    onChange={handleSourceChange}
                    options={sourceList}
                    getOptionLabel={(option) => `${option.name}`}
                    placeholder={translate("selectSource")}
                    error={!!errors.source}
                  />
                  {errors.source && (
                    <FormHelperText error>{errors.source}</FormHelperText>
                  )}
                </Grid>
                <Grid
                  size={{ xs: 12, sm: 1, lg: 2 }}
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignContent: "flex-end",
                    mb: 2,
                  }}
                >
                  <Typography>
                    {formatCurrency(source?.availableBalance)}
                  </Typography>
                </Grid>
                <Grid size={12}>
                  <StyledInputLabel shrink>
                    {translate("paymentAmount")}{" "}
                    <span style={{ color: "red" }}>*</span>
                  </StyledInputLabel>
                  <RadioGroup
                    row
                    value={radioPayment}
                    onChange={handlePaymentAmountChange}
                  >
                    <Box>
                      <FormControlLabel
                        value="amountDue"
                        control={<Radio />}
                        label={`Amount Due ${outstandingBalance}`}
                      />
                      {errors.amountDue && (
                        <FormHelperText sx={{ color: "#d32f2f" }}>
                          {errors.amountDue}
                        </FormHelperText>
                      )}
                    </Box>
                    <FormControlLabel
                      sx={{
                        mb:
                          errors.amountDue || errors.OtherpaymentAmount ? 3 : 0,
                      }}
                      value="OtherAmount"
                      control={<Radio />}
                      label="Other Amount"
                    />
                    {radioPayment === "OtherAmount" && (
                      <FormControl>
                        <NumericFormat
                          placeholder="0.00"
                          thousandSeparator={true}
                          decimalScale={2}
                          allowNegative={false}
                          value={OtherpaymentAmount}   // 👈 fallback to 0 if null, undefined, or NaN
                          onValueChange={(values) => {
                            handleOtherPaymentAmountChange(values.value); // values.value is numeric string without formatting
                          }}
                          isAllowed={(values) => {
                            const { floatValue } = values;
                            return (
                              floatValue === undefined ||
                              floatValue <= constants.MAX_AMOUNT_ALLOWED
                            );
                          }}
                          customInput={CustomTextField}
                          error={Boolean(errors.OtherpaymentAmount)}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">$</InputAdornment>
                            ),
                          }}
                        />
                        {radioPayment === "OtherAmount" &&
                          errors.OtherpaymentAmount && (
                            <FormHelperText sx={{ ml: 0 }} error>
                              {errors.OtherpaymentAmount}
                            </FormHelperText>
                          )}
                      </FormControl>
                    )}
                  </RadioGroup>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                  <StyledInputLabel shrink>
                    {translate("paymentDate")}{" "}
                    <span style={{ color: "red" }}>*</span>
                  </StyledInputLabel>
                  <CustomDatePicker
                    value={paymentDate ? dayjs(paymentDate) : null}
                    readOnly
                  />
                </Grid>
              </Grid>
            </Box>
          </StyledTwoChildContainer>
          <div className="right-fields" style={{ marginTop: "10px" }}>
            <ContainedButton sx={{ mr: 2 }} onClick={handleContinueClick} disabled={restrictedRoles.includes(userInfo?.roles?.roleName ?? '')}>
              {translate("continue")}{" "}
            </ContainedButton>
            <OutlinedButton onClick={handleCancel}>
              {translate("cancel")}
            </OutlinedButton>
          </div>
          <CancelPopUp
            open={openPopUp}
            popupTitle={translate("confirmCancel")}
            handleClose={handlePopUpClose}
            saveChanges={() => handleConfirm()}
            message={translate("doYouWantToCancelChanges?")}
          />
        </StyledTwoChildContainer>
      </StyledOneChildContainer>
    </StyledParentContainer>
  );
};

export default MakePayment;
